/**
 * @fileoverview Contexto responsável por disponibilizar autenticação, usuário e ações de sessão para a aplicação.
 */

import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading,
		user,
		isAuth,
		impersonation,
		handleLogin,
		handleLoginMfa,
		finalizeMfaSetupSession,
		startSession,
		handleLogout,
		impersonateUser,
		superSwitchCompany,
		switchCompany,
		listSiblingAccounts,
		returnFromImpersonation,
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading,
				user,
				isAuth,
				impersonation,
				handleLogin,
				handleLoginMfa,
				finalizeMfaSetupSession,
				startSession,
				handleLogout,
				impersonateUser,
				superSwitchCompany,
				switchCompany,
				returnFromImpersonation,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
